
export const revocationValidationRules = {
    "id": ["notEmpty"],
    "to": ["notEmpty", "earlierThan"],
};
